import { MovieClip, animate } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { IEffect } from '../../actions/effects/IEffect';
import { app } from '../../app';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { getMatch2AssetPath } from '../../util/assets';
import { blockViewAssets } from '../../util/blockTools';
import { PiggyBankBlockEntity } from './PiggyBankBlockEntity';

export class PiggyBankBlockEffect implements IEffect {
  private readonly scene: GameScene;

  constructor(scene: GameScene) {
    this.scene = scene;
  }

  public static assets() {
    return blockViewAssets('piggyBank');
  }

  public async execute() {
    //
  }

  public async animateBreakParticles(entity: PiggyBankBlockEntity) {
    const textures: string[] = [
      getMatch2AssetPath('blocks/piggyBank/particles/particle_coin_0001.png'),
      getMatch2AssetPath('blocks/piggyBank/particles/particle_coin_0002.png'),
      getMatch2AssetPath('blocks/piggyBank/particles/particle_coin_0003.png'),
      getMatch2AssetPath('blocks/piggyBank/particles/particle_coin_0004.png'),
    ];

    const particles = app.particles.create({
      textures,
      rate: 0,
      limit: 10,
      emitterDuration: 0,
      duration: 1,

      velocity: { x: 0, y: -800 },
      scale: [
        { x: 0.5, y: 0.5 },
        { x: 0.8, y: 0.8 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [200, 300] },
        { type: 'gravity', gravity: { x: 0, y: 3000 } },
        { type: 'scale', to: [1.3, 1.7] },
        { type: 'fade', to: 0, tween: animate.easeInExpo },
        { type: 'kinematic', directionalRotation: true },
      ],
    });

    const position = entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }

  public async animateBreakExplosion(entity: PiggyBankBlockEntity) {
    const container = new Container();
    const movieclip = new MovieClip({
      superview: container.view,
      url: getMatch2AssetPath('blocks/piggyBank/movieclip'),
    });
    const overlay = spawnOverlayEntity(
      this.scene,
      entity.c.position.mapPosition,
      entity.c.block.props,
      () => container,
      'foreground',
    );
    await movieclip.playAsync('piggybank_stage3');
    despawnOverlayEntity(this.scene, overlay);
  }
}
